/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';

import {
  HeroImage,
  IHeroImageProps,
  HeroContent,
  IHeroContentProps,
  HeroList,
  IHeroListProps,
  HeroButtons,
  IHeroButtonProps,
  HeroDescription,
  IHeroDescriptionProps,
  CarouselSection,
  ICarouselSectionProps,
  AccordionComp,
  IAccordionProps,
  PdfViewerModal,
  IPdfViewerModalProps,
  ImageModal,
  IImageModalProps,
  IStatusCompProps,
  StatusComp,
} from './components';

export type IHeroSectionDetailWidgetProps = IHeroImageProps &
  IHeroContentProps &
  IHeroListProps &
  IHeroButtonProps &
  IHeroDescriptionProps &
  IAccordionProps &
  IPdfViewerModalProps &
  IImageModalProps &
  IStatusCompProps;

export const HeroSectionDetailWidget = (
  props: IHeroSectionDetailWidgetProps
) => {
  const {
    title,
    subtitle,
    image,
    listItems,
    buttons,
    heroTitle,
    description,
    carouselItems,
    policyDetails,
    beneficiaryDetails,
    profileStatus,
    profileStatusDescription,
  } = props;
  const [imageModalObj, setImageModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });
  const [pdfModalObj, setPdfModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });
  const _onCarouselImageClick = async (item: ICarouselItem) => {
    if ((item?.type === 'img' || item?.type?.includes('image')) && item?.src) {
      setImageModalObj({
        ...imageModalObj,
        src: item.src,
        title: item.title,
        enableVisibility: true,
      });
    }
    if ((item?.type === 'pdf' || item?.type?.includes('pdf')) && item?.src) {
      // await WebBrowser.openBrowserAsync(item.src);
      setPdfModalObj({
        ...pdfModalObj,
        src: item?.src,
        title: item.title,
        enableVisibility: true,
      });
    }
  };
  const _onDeny = () => {
    setImageModalObj({
      ...imageModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };

  const onPdfClose = () => {
    setPdfModalObj({
      ...pdfModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };
  const _renderHeroImage = () => {
    if (image) {
      return <HeroImage {...props} />;
    }
  };

  const _renderHeroContent = () => {
    return (
      <Col xs={12} lg={10} className="justify-content-center text-align-center">
        {(title || subtitle) && <HeroContent {...props} />}
        {profileStatus && <StatusComp {...(props || {})} />}
        {listItems && <HeroList {...props} />}
        {buttons && <HeroButtons {...props} />}
      </Col>
    );
  };

  const _renderDescription = () => {
    if (heroTitle || description) {
      return (
        <>
          <hr />
          <HeroDescription {...props} />
        </>
      );
    }
  };

  const _renderCarousel = () => {
    if (Array.isArray(carouselItems) && carouselItems?.length > 0) {
      return (
        <>
          <hr className="mt-2" />
          <CarouselSection
            onCarouselImageClick={_onCarouselImageClick}
            carouselItems={carouselItems}
          />
        </>
      );
    } else if (Array.isArray(carouselItems) && carouselItems?.length === 0) {
      return (
        <div style={{ display: 'block' }} className={'m-5 p-5'}>
          <Spinner animation="border" variant="primary" size="lg" />
        </div>
      );
    }
  };

  const _renderAccordion = () => {
    if (policyDetails || props?.timelineDetails) {
      return <AccordionComp {...(props || {})} />;
    }
  };

  return (
    <Row className="justify-content space-around">
      {_renderHeroImage()}
      {_renderHeroContent()}

      {_renderDescription()}
      {_renderCarousel()}
      {_renderAccordion()}
      <PdfViewerModal
        {...(props || {})}
        showModal={pdfModalObj?.enableVisibility}
        title={pdfModalObj?.title}
        file={pdfModalObj?.src}
        onPdfClose={onPdfClose}
      />
      <ImageModal
        {...AccordionComp(props || {})}
        showModal={imageModalObj?.enableVisibility}
        title={imageModalObj?.title}
        imageSrc={imageModalObj?.src}
        onDeny={_onDeny}
      />
    </Row>
  );
};

HeroSectionDetailWidget.defaultProps = {};
